import React, { useCallback, useMemo, useState } from 'react';
import { Box, Paper } from '@mui/material';
import DateFnsUtils from '@date-io/date-fns';
//
import FilterPanel from './FilterPanel';
import Title from 'components/common/Title';
import { CLIENTS_TRANSACTIONS_HISTORY_COLUMN_DEFS } from 'utils/tables/columns/transactionsHistory';
import { StyledTransactionsGrid } from '../transactions.styles';
import { useGetClientTransactionsQuery } from '../../../store/api/transaction.api';
import { DEFAULT_DATE_FORMAT } from '../../../constants/reports';
import { useDefaultReportRange } from 'hooks/utils/useDefaultReportRange';
const dateFns = new DateFnsUtils();

const TransactionHistoryTable = (props) => {
  const { startDate, endDate } = useDefaultReportRange();
  const [filters, setFilters] = useState({ startDate, endDate });
  const queryParams = useMemo(
    () => ({
      ...filters,
      startDate: dateFns.format(filters.startDate, DEFAULT_DATE_FORMAT),
      endDate: dateFns.format(filters.endDate, DEFAULT_DATE_FORMAT),
    }),
    [filters],
  );
  const { data: transactions = [], isFetching } =
    useGetClientTransactionsQuery(queryParams);

  const applyFilters = useCallback(
    (filters) => {
      setFilters({ ...filters, ts: Date.now() });
    },
    [setFilters],
  );

  return (
    <Paper>
      <div style={{ width: '100%', marginTop: '15px', marginBottom: '15px' }}>
        <Box sx={{ pt: 2, px: 2 }}>
          <Title>Clients Transaction History</Title>
        </Box>
        <Box>
          <FilterPanel
            clientOptionsData={props.clientOptionsData}
            publisherOptionsData={props.publisherOptionsData}
            endpointOptionsData={props.endpointOptionsData}
            applyFilters={applyFilters}
            initialValues={filters}
          />
        </Box>
        <Box sx={{ pt: 2, px: 2, paddingBottom: '15px' }}>
          <StyledTransactionsGrid
            rows={transactions}
            loading={isFetching}
            columns={CLIENTS_TRANSACTIONS_HISTORY_COLUMN_DEFS}
            disableRowSelectionOnClick
          />
        </Box>
      </div>
    </Paper>
  );
};

export default TransactionHistoryTable;
